export default __webpack_public_path__ + "static/media/head-right-side.b60d66e4.png";